import { useState } from 'react';
import { styled } from '@mui/material';
import type { ImageProps } from 'next/image';
import { allowedImageDomains } from './allowedImageDomains';

const ImageContainerScreenshotImage = styled('div')`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;

  #app-screenshot-image-custom {
    border-radius: 12px;
  }

  @media (max-width: 500px) {
    #app-screenshot-image-custom {
      height: auto !important;
      min-height: auto !important;
    }
  }
`;

/**
 * Props for the AppScreenshotImage component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @param {ImageProps} props - The props for the AppScreenshotImage component.
 * @param {React.ComponentType<ImageProps>} FlexibleImageComponent The image component to use.
 * @returns {JSX.Element} The AppScreenshotImage component.
 */
export const AppScreenshotImage = ({
  src = '#',
  alt,
  fallbackImageURL = '#',
  FlexibleImageComponent,
}: ImageProps & {
  fallbackImageURL?: string;
  FlexibleImageComponent: React.ComponentType<ImageProps>;
}) => {
  const matchingDomain =
    process.env.NODE_ENV === 'development'
      ? allowedImageDomains.domains.find((domain) =>
          src?.toString()?.includes(domain)
        )
      : true;

  const [imageURL, setImageURL] = useState(src);

  const handleError = () => {
    console.error('Image failed to load, switching to fallback URL');
    setImageURL(fallbackImageURL);
  };

  return (
    <ImageContainerScreenshotImage>
      {matchingDomain && (
        <FlexibleImageComponent
          id="app-screenshot-image-custom"
          fill
          style={{ objectFit: 'contain' }}
          src={imageURL}
          onError={handleError}
          alt={alt}
        />
      )}
    </ImageContainerScreenshotImage>
  );
};
